import { Transition_Child_default } from "./chunk-EG4OCGJ6.js";
import { Transition_default } from "./chunk-ZGFMB7MJ.js";

// src/elements/Transition/index.ts
var TransitionComponent = Transition_default;
TransitionComponent.Child = Transition_Child_default;
TransitionComponent.Child.displayName = "Transition.Child";
export { TransitionComponent };